import { Address } from '@/models/common/address';
import { UserEntityPermissionsType } from '@/models/users/user-permissions/user-entity-permissions';

export class Company {
    public id: number = 0;
    public ownerId: number = 0;
    public taxCode?: string;
    public name?: string;
    public fiscalAddress: Address = new Address();

    public get permissionsGroupType(): UserEntityPermissionsType {
        return UserEntityPermissionsType.Companies;
    }

    public get permissionsIdToCheck(): number {
        return this.id;
    }

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(
            this,
            json,
            {
                fiscalAddress: new Address(json.fiscalAddress),
            });
    }

    public clone(): Company {
        const company: Company = new Company();

        company.id = this.id;
        company.ownerId = this.ownerId;
        company.taxCode = this.taxCode;
        company.name = this.name;
        company.fiscalAddress = this.fiscalAddress!.clone();

        return company;
    }
}
